<template>
  <div>
    <el-row v-loading="loading">
      <el-col :span="24" :style="{'padding':workPcOrPhone}">
        <el-form ref="form" :model="form"  :rules="rules" :label-width="PcOrPhone=='Phone'?'':labelWidth" v-if="dataWaitFalg">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="language=='cn'?'参赛项目':'type of works:'">
                <el-select
                  :disabled="!(form.id==undefined||form.id=='')"
                  @change="changeFormType()"
                  v-model="form.categoryId"
                  :placeholder="language=='cn'?'请选择参赛项目':'Please select the work type'">
                  <el-option :key="workType.id" :label="language=='cn'?workType.name:workType.englishName" :value="workType.id" v-for="workType in workTypeList"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" :key="field.id" v-for="(field,index) in fieldList">
              <el-form-item :prop="field.labelField" v-if="form[field.key]==field.val && field.show && field.divisionShowValue">
                <span slot="label">
                  <el-tooltip effect="light" placement="top" v-if="field.tipFalg">
                    <div slot="content">
                      <div v-html="language=='cn'?field.tipContent:field.enTipContent"></div>
                    </div>
                      <i  class="el-icon-question"/>
                  </el-tooltip>
                  {{language=='cn'?field.labelName:field.enLabelName}}
                </span>
                <el-button size="small" type="primary" @click="templateDownload(field)" v-if="field.mouldFieldObj||field.enMouldFieldObj">{{language=='cn'?'模板下载':'Template download'}}</el-button>
                <!--                  <span v-for="file in field.enMouldFieldObj" v-if="field.enMouldFieldObj"></span>-->
                <el-input :disabled="disabledFalg" v-model="form[field.labelField]" :placeholder="language=='cn'?field.remark?field.remark:'请输入'+field.labelName:field.enRemark?field.enRemark:'please enter'+field.enLabelName" v-if="field.fieldType=='input'" />
                <el-input maxlength="500" :disabled="disabledFalg" type="textarea" :rows="2" :placeholder="language=='cn'?field.remark?field.remark:'请输入'+field.labelName:field.enRemark?field.enRemark:'please enter'+field.enLabelName" v-model="form[field.labelField]" v-if="field.fieldType=='textarea'"></el-input>
                <el-select filterable :disabled="disabledFalg" v-model='form[field.labelField]' :placeholder="language=='cn'?field.remark?field.remark:'请选择'+field.labelName:field.enRemark?field.enRemark:'please choose'+field.enLabelName" v-if="field.fieldType=='select'">
                  <el-option
                    :key="dic.dictCode"
                    :label="dic.dictLabel"
                    :value="dic.dictValue"
                    v-for="dic in dictionaryDataMap.get(field.labelField)">
                  </el-option>
                </el-select>
                <el-radio  :disabled="disabledFalg" :key="dic.dictCode" :label="dic.dictValue" v-model="form[field.labelField]" v-for="dic in dictionaryDataMap.get(field.labelField)" v-if="field.fieldType=='radio'">
                  {{language=='cn'?dic.dictLabel:dic.enDictLabel}}
                  <i :title="language=='cn'?dic.remark:dic.enRemark"  class="el-icon-question"/>
                </el-radio>
                <!-- <file-upload :language="language" :remark="form.id?form[field.labelField]:undefined" :file-type="field.fileType?JSON.parse(field.fileType):[]" :label-field="field.labelField" v-if="field.fieldType=='upload'" :tip-text="language=='cn'?field.remark:field.enRemark" :max-size="field.fileSize" @getRemark="getRemark" :disabled="disabledFalg" :multiple="false" :max-upload-num="field.fileNum"></file-upload> -->
                <file-upload-bos v-if="field.fieldType=='upload'" :language="language" :remark="form.id?form[field.labelField]:undefined" :file-type="field.fileType?JSON.parse(field.fileType):[]" :label-field="field.labelField" :tip-text="language=='cn'?field.remark:field.enRemark" :max-size="field.fileSize" @getRemark="getRemark" :disabled="disabledFalg" :multiple="false" :max-upload-num="field.fileNum"></file-upload-bos>
                <file-component :disabled-falg="disabledFalg" :language="language" :remark="form.id?form[field.labelField]:undefined" @onFileSuccess="onFileSuccess" :label-field="field.labelField" v-if="field.fieldType=='breakpointUpload'" :msg="language=='cn'?field.remark:field.enRemark" :max-size="field.fileSize" :upload-type="field.fileType?JSON.parse(field.fileType):[]" :max-upload-num="field.fileNum"></file-component>
               <el-row v-if="form[field.key]==field.val">
                  <el-col :span="24" style="padding-left: 0px!important;">
                    <!--关联字典-->
                    <el-radio  v-model="form[field.correlationType]"   :disabled="disabledFalg" :key="dic.dictCode" :label="dic.dictValue" v-for="dic in dictionaryDataMap.get(field.correlationType)" >
                      {{language=='cn'?dic.dictLabel:dic.enDictLabel}}
                    </el-radio>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
    <el-dialog
      :title="language=='cn'?'模板下载':'Template download'"
      :visible.sync="templateDownloadFalg"
      width="25%">
       <div v-for="file in templateDownloadObj.mouldFieldObj" v-if="templateDownloadObj.mouldFieldObj">
         <el-row>
           <el-col :span="24">
             <span style="font-size: 15px">{{language=='cn'?'文件名：':'File Name :'}}{{file.fileName}}</span>
             <a target="_blank" :href="file.path" style="padding-left: 10px">
               <el-tag effect="dark">
                 <i class="el-icon-download"></i>
               </el-tag>
             </a>
           </el-col>
         </el-row>
       </div>
      <span slot="footer" class="dialog-footer">
                    <el-button @click="templateDownloadFalg = false">{{language=='cn'?'取 消':'cancel'}}</el-button>
                    <el-button type="primary" @click="templateDownloadFalg = false">{{language=='cn'?'确 定':'confirm'}}</el-button>
                  </span>
    </el-dialog>
    <div>
      <div slot="footer" class="dialog-footer" style="text-align: center;padding-bottom: 20px" >
        <div>
          <el-checkbox v-model="checked">{{language=='cn'?'我已阅读且同意':'I have read and agree to the'}}</el-checkbox>
          <span @click="commitmentOpen(language=='cn'?136:186)" style="font-size: 14px;color: #409eff;cursor: pointer">{{language=='cn'?'《参赛须知》':'《Contest Rules》'}}</span>
        </div>
        <div>
          <el-row>
            <div  v-if="hideBuutonFalg">
              <el-col :span="8" :offset="1" style="text-align: right">
              <el-button v-if="!disabledFalg&&temporaryFalg&&updateFalg" :disabled="saveFalg||submitFormFalg" type="primary" @click="submitForm(false)">{{ language == 'cn' ? '暂存' : 'Temporary storage' }}
                </el-button>
              </el-col>
              <el-col :span="2" :offset="!disabledFalg==true?1:8" style="text-align: right">
                <el-button type="primary" v-if="!disabledFalg&&temporaryFalg"  :disabled="saveFalg||submitFormFalg" @click="submitForm(true)">{{language=='cn'?'提交':'save'}}</el-button>
              </el-col>
              <el-col :span="8" v-if="updateFalg" :offset="!disabledFalg==true?1:10" style="text-align: left">
                <el-button @click="cancel()">{{language=='cn'?'返 回':'return'}}</el-button>
              </el-col>
            </div>
          </el-row>
          <el-row>
            <p style="color: #ff0000;font-size: 12px;margin-left: 161px;width: 60%;">首次提交，提交后申报材料不可修改，如需修改，需向赛区管理员申请退回。
              退回的作品需要重新提交，则需先点击左侧的“提交“按钮上传资料，然后点击右侧的”重新提交“按钮重新提交资料。</p>
          </el-row>
        </div>
      </div>
    </div>
    <commitment
      :dataSourceVisible="dataSourceVisible"
      :commitmentVal="commitmentVal"></commitment>
  </div>
</template>

<script>
import commitment from '@/components/commitment'
import FileUpload from './fileUpload'
import FileUploadBos from '@/components/fileUploadBos'
import FileComponent from './fileComponent'
import {listWorkfield} from '../api/work/workfield'
import {addData, addDynamicDataDelTemporaryData, addTemporary, editTemporary, updateData} from '../api/work/workdata'
import {delStorageByRemark, listStorage} from '../api/system/objectStorage'
import {getDicts, conditionByParticipantData} from '../api/registerForm'
import {listShow } from '../api/work/show'

export default {
  name: 'workForm',
  components: {FileComponent, FileUpload, FileUploadBos, commitment},
  props: [ 'workTypeList', 'formObj', 'siteId', 'divisionId', 'formType', 'disabledFalg', 'language', 'temporaryFalg', 'teamUserId'],
  data () {
    return {
      updateFalg: true,
      submitFormFalg: false,
      hideBuutonFalg: true,
      saveFalg: false,
      commitmentVal: undefined,
      dataSourceVisible: false,
      checked: false,
      loading: true,
      userList: [],
      labelWidth: '180px',
      dataWaitFalg: true,
      fieldList: [],
      rules: {
        userId: [
          { required: true, message: '请选择报名用户', trigger: 'blur' }
        ],
        categoryId: [
          { required: true, message: '请选择赛题组', trigger: 'blur' }
        ]
      },
      dictionaryDataMap: {},
      regularDicts: [],
      regularDictsMap: {},
      hashAry: [],
      submitNum: 0,
      submitFalg: false,
      templateDownloadFalg: false,
      templateDownloadObj: false,
      PcOrPhone: '',
      workPcOrPhone: '',
      form: {}
    }
  },
  created () {
    this.form = {...this.formObj}
    this.form.categoryId = this.formType
    this.getFieldList()
    this.initForm()
    // this.getsingUpData(this.form.competitionProject)
  },
  mounted () {
    this.$forceUpdate()
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if (flag) {
      this.PcOrPhone = 'Phone'
      this.PcOrPhoneStyle = '24'
      this.workPcOrPhone = '0'
    } else {
      this.PcOrPhone = 'pc'
      this.PcOrPhoneStyle = '12'
      this.workPcOrPhone = '20px 180px 0 0'
    }
  },
  methods: {
    hideBuuton () {
      this.hideBuutonFalg = true
      this.temporaryFalg = true
      this.updateFalg = false
    },
    /* getsingUpType(){
      //根据类型切换报名信息
      let category = this.form.competitionProject
      debugger
      if(this.form.categoryId == 53){
        category = 1
      }else if(this.form.categoryId == 54){
        category = 2
      }else if(this.form.categoryId == 55){
        category = 3
      }
      this.getsingUpData(category)
    }, */
    /* getsingUpData(category){
       conditionByParticipantData(this.baseURL, {
        siteId: this.siteId,
        userId: this.$store.state.user.userId,
        competitionProject:category
      }).then(res => {
        debugger
         if (res.data.length == 0) {
           alert("当前所选赛题未报名,请报名后进行作品提交。")
           this.saveFalg = false
        } else {
          this.form.participantId = res.data[0].id
        }
      });
    }, */
    async changeFormType () {
      // this.getsingUpType()
      await this.getFieldList()
      await this.initForm()
    },
    commitmentOpen (val) {
      this.dataSourceVisible = !this.dataSourceVisible
      this.commitmentVal = val
    },
    templateDownload (field) {
      if (field.mouldFieldObj || field.enMouldFieldObj) {
        this.templateDownloadFalg = true
        this.templateDownloadObj = {...field}
      }
    },
    onFileSuccess (falg, remark, labelField) {
      this.submitFalg = falg
      this.form[labelField] = remark
    },
    getRemark (labelField, remark) {
      this.form[labelField] = remark
    },
    initForm () {
      // 查询所有表单用到的字典数据
      let map = new Map()
      this.fieldList.forEach((field, index) => {
        if (field.type) {
          getDicts(this.systemURL, field.type).then(res => {
            console.log(res)
            map.set(field.labelField, res.data)
            this.$forceUpdate()
          })
        }
        if (field.relevanceType) {
          if (!field.relevanceTypeFalg) {
            let relevanceTypeAry = JSON.parse(field.relevanceType)
            relevanceTypeAry.forEach(item => [
              getDicts(this.systemURL, item[1]).then(res => {
                map.set(item[0], res.data)
                let copyObj = {}
                copyObj.fieldType = {...field}.fieldType
                copyObj.relevanceType = {...field}.relevanceType
                copyObj.correlationType = item[0]
                copyObj.labelName = res.data[0].remark
                copyObj.relevanceTypeFalg = false
                copyObj.key = {...field}.labelField
                copyObj.val = item[0].split(':')[1]
                this.fieldList.splice(index + 1, 0, copyObj)
                this.$forceUpdate()
              })
            ])
          }
        }
      })
      this.dictionaryDataMap = map
      // 查询表单验证规则
      getDicts(this.systemURL, 'regular_type').then(res => {
        this.regularDicts = res.data
        // 将验证规则存如map
        this.regularDictsMap = new Map()
        this.regularDicts.forEach(item => {
          this.regularDictsMap.set(item.dictCode, item)
        })
      })
      this.getFormListVerify()
    },
    // 动态生成表单验证规则
    getFormListVerify () {
      // 根据站点id查询表单配置信息
      let that = this
      this.fieldList.forEach(verify => {
        if (verify.regular) {
          let rulesAry = []
          // 将字典code切分成数组，数据库存储结构是字符串类似1，2，3，4
          verify.regular.split(',').forEach(v => {
            if (v) {
              // 封装验证
              rulesAry.push({
                validator: (rule, value, callback) => {
                  let regular = that.regularDictsMap.get(parseInt(v))
                  if (regular) {
                    if (verify.required) {
                      if (!value) {
                        return callback(new Error(that.language === 'cn' ? verify.labelName + '不能为空' : verify.enLabelName + ' can not be empty'))
                      }
                    }
                    if (!value) {
                      // 不是必填但是有校验规则，只在有值的情况下就行规则校验
                      return callback()
                    }
                    // 正则校验
                    if (!new RegExp(regular.dictValue).test(value)) {
                      return callback(new Error(that.language === 'cn' ? regular.remark : regular.enRemark))
                    } else {
                      // 数据校验成功，放行
                      return callback()
                    }
                  } else {
                    // 没有校验规则直接放行
                    return callback()
                  }
                },
                trigger: 'blur'
              })
            }
          })
          if (this.rules[verify.labelField]) {
            this.rules[verify.labelField].concat(rulesAry)
          } else {
            this.rules[verify.labelField] = rulesAry
          }
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    async submitForm (falg) {
      if (!this.checked) {
        this.$message.info(this.language === 'cn' ? '请阅读并同意《参赛须知》' : 'Please agree and read the Contest Rules')
        return
      }
      let ary = this.fieldList.filter((f) => {
        return f.fieldType === 'breakpointUpload'
      })
      if (ary.length === 0) {
        this.submitFalg = true
      }
      let that = this
      if (falg) {
        this.$refs['form'].validate(async valid => {
          if (that.submitFalg === false) {
            that.$message.error(this.language === 'cn' ? '上传文件数量超过最大上传数量' : 'The number of uploaded files exceeds the maximum number of uploaded files')
            return
          }
          if (valid) {
            this.checkForm(falg)
          }
        })
      } else {
        this.checkForm(falg)
      }
    },
    async checkForm (falg) {
      if (this.teamUserId) {
        this.form.userId = this.teamUserId
      } else {
        this.form.userId = this.$store.state.user.userId
      }
      let formData = {}
      this.form.siteId = this.siteId
      this.form.divisionId = this.divisionId
      this.fieldList.forEach(item => {
        if (item.labelField) {
          formData[item.labelField] = this.form[item.labelField]
        } else {
          formData[item.correlationType] = this.form[item.correlationType]
        }
      })
      this.form.data = JSON.stringify(formData)
      this.fieldList.forEach(item => {
        if (item.labelField) {
          formData[item.labelField] = this.form[item.labelField]
        } else {
          formData[item.correlationType] = this.form[item.correlationType]
        }
      })
      this.form.data = JSON.stringify(formData)
      this.submitFormFalg = true
      if (falg) {
        // 是否是暂存
        if (this.temporaryFalg && this.updateFalg) {
          let temporaryId = this.form.id
          this.form.id = undefined
          await addDynamicDataDelTemporaryData(this.siteURL, {
            dynamicData: this.form,
            temporaryId: temporaryId
          }).then(res => {
            this.$message.success(this.language === 'cn' ? '作品提交成功' : 'Successful submission')
            this.form.id = res.data
            this.cancel()
          }).catch(e => {
            this.submitFormFalg = false
          })
        } else {
          if (!this.form.id) {
            await addData(this.siteURL, this.form).then(res => {
              this.$message.success(this.language === 'cn' ? '添加成功' : 'successfully added')
              this.form.id = res.data
            }).catch(e => {
              this.submitFormFalg = false
            })
            this.cancel()
          } else {
            await updateData(this.siteURL, this.form).then(res => {
              this.$message.success(this.language === 'cn' ? '修改成功' : 'modify successfully')
              this.$emit('updataWorkStatus', true)
            }).catch(e => {
              this.submitFormFalg = false
            })
            this.cancel()
          }
        }
      } else {
        if (!this.form.id) {
          await addTemporary(this.siteURL, this.form).then(res => {
            this.$message.success(this.language === 'cn' ? '暂存作品添加成功' : 'Temporary submission succeeded')
            this.form.id = res.data
            this.cancel()
          }).catch(e => {
            this.submitFormFalg = false
          })
        } else {
          await editTemporary(this.siteURL, this.form).then(res => {
            this.$message.success(this.language === 'cn' ? '暂存作品修改成功' : 'Temporary modification succeeded')
            this.cancel()
          }).catch(e => {
            this.submitFormFalg = false
          })
        }
      }
    },
    jumpRouter () {
      this.$router.push({
        path: this.language === 'cn' ? '/myHome' : '/enMyHome',
        query: { articleId: '2' }
      })
    },
    delFiles (remark) {
      delStorageByRemark(this.systemURL, remark)
    },
    cancel () {
      this.$emit('back', false)
    },
    getFieldList () {
      let that = this
      listWorkfield(this.siteURL, {
        siteId: this.siteId,
        formType: this.form.categoryId
      }).then(res => {
        this.fieldList = res.rows
        console.log(res.rows)
        // 对作品字段list进行循环遍历赋值赛区显示状态
        for (let index = 0; index < this.fieldList.length; index++) {
          let id = this.fieldList[index].id
          listShow(this.siteURL, {workFieldId: id, divisionId: this.divisionId}).then((res) => {
            if (res.rows.length > 0) {
              this.fieldList[index].divisionShowValue = res.rows[0].ifShow
            }
          })
        }
        if (this.fieldList.length > 0) {
          // 此处添加必填项的红点提示，表单生成之后再渲染没有此规则
          this.fieldList.forEach(item => {
            this.rules[item.labelField] = []
            if (item.required) {
              if (item.fieldType !== 'division' && item.fieldType !== 'breakpointUpload' && item.fieldType !== 'upload') {
                this.rules[item.labelField] = [
                  { required: true, message: this.language === 'cn' ? item.labelName + '不能为空' : item.enLabelName + ' can not be empty', trigger: 'blur' }
                ]
              } else {
                // 文件上传校验
                this.rules[item.labelField] = [
                  // { required: true, message: this.language=='cn'?item.labelName+'不能为空':item.enLabelName+' can not be empty', trigger: 'blur' },
                  { required: true,
                    validator: (rule, value, callback) => {
                    // 已经上传了文件
                      if (that.form[item.labelField]) {
                        listStorage(this.systemURL, {
                          remark: that.form[item.labelField]
                        }).then(res => {
                          if (res.rows.length > 0) {
                            return callback()
                          } else {
                            return callback(new Error(that.language === 'cn' ? item.labelName + '不能为空' : item.enLabelName + ' can not be empty'))
                          }
                        })
                      } else {
                      // 未上传文件
                        return callback(new Error(that.language === 'cn' ? item.labelName + '不能为空' : item.enLabelName + ' can not be empty'))
                      }
                    },
                    trigger: 'blur' }
                ]
              }
            }
          })
          this.initForm()
        } else {
          this.$message.info(this.language === 'cn' ? '作品申报信息尚未配置' : 'Work declaration information has not been configured')
          this.saveFalg = true
          this.loading = false
        }
      })
    }
  },
  // 页面销毁前如果没有提交表单则需要删除上传的文件
  beforeDestroy () {
    if (!this.form.id) {
      this.fieldList.forEach(f => {
        if (f.fieldType === 'breakpointUpload' || f.fieldType === 'upload') {
          let remark = this.form[f.labelField]
          if (remark) {
            this.delFiles(remark)
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/workForm.vue